import React, { Component } from 'react'

import { callReAuth } from '../utils/venice'
import allEvents from '../utils/events'
import serverData from '../utils/server-data'

const sessionTimerHoc = (WrappedComponent) => {
  class SessionTimer extends Component {
    events = allEvents
    expireTime = 15 * 60 * 1000 // 15 minutes

    clearSessionTimer = () => {
      if (this.sessionTimeoutId) {
        window.clearTimeout(this.sessionTimeoutId)
        this.setSessionTimer()
      }
    }

    setSessionTimer = () => {
      this.sessionTimeoutId = setTimeout(() => {
        callReAuth()
      }, this.expireTime)
    }

    componentDidMount() {
      this.events.forEach((event) => {
        document.addEventListener(event, this.clearSessionTimer)
      })
      this.setSessionTimer()
    }

    componentWillUnmount() {
      this.clearSessionTimer()
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
  return serverData.isNative ? SessionTimer : WrappedComponent
}

export default sessionTimerHoc
